/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, Input } from "@angular/core";

import { Rule } from "../../../models/rule";

@Component({
  selector: 'app-time-filter-editor',
  templateUrl: './time-filter-editor.component.html'
})
export class TimeFilterEditorComponent implements OnInit {

    @Input()
    rule: Rule;

    showBody: boolean = true;
    
    days = [
        { label: 'MON.', value: 'MONDAY', checked: true},
        { label: 'TUES.', value: 'TUESDAY', checked: true},
        { label: 'WED.', value: 'WEDNESDAY', checked: true},
        { label: 'THUR.', value: 'THURSDAY', checked: true},
        { label: 'FRI.', value: 'FRIDAY', checked: true},
        { label: 'SAT.', value: 'SATURDAY', checked: true},
        { label: 'SUN.', value: 'SUNDAY', checked: true}
    ];
    
    ngOnInit(): void {
       if (this.rule.days != null && this.rule.days.length < 7) {
           for (let day of this.days) {
              if (this.rule.days.indexOf(day.value) == -1) {
                  day.checked = false;
              }
           }
       }
    }
    
    onDayClick(event: any): void {
        console.log(event.target);
        console.log(event.target.checked);
        console.log(event.target.value);
        
        if (event.target.checked) {
            this.rule.days.push(event.target.value);
        }
        else {
            var index = this.rule.days.indexOf(event.target.value);
            if (index != -1) {
                this.rule.days.splice(index, 1);
            }
        }
        
        console.log(this.rule.days);
        console.log(this.rule.startTime + '\t' + this.rule.endTime);
    }
    
    onRemove(): void {
        this.rule.days = null;
        this.rule.startTime = null;
        this.rule.endTime = null;

        this.days.forEach(day => day.checked = false);
    }

}
